import {
  ApiResponse,
  Clinic,
  ClinicUser,
  PaginationResponse,
  User,
} from '@magnetar/admin-api-interfaces'
import { useAuth } from './useAuth'
import { useGet } from './useFetch'

interface UseProviderClinicUsersParams {
  page?: number
  pageSize?: number
  account?: string
  clinicId?: number
}

export function useProviderClinicUsers({
  page = 1,
  pageSize = 20,
  account,
  clinicId,
}: UseProviderClinicUsersParams = {}) {
  const { token } = useAuth()

  const params: Record<string, unknown> = {
    page,
    pageSize,
  }

  if (account) params.account = account
  if (clinicId) params.clinic_id = clinicId

  const { data, error, mutate } = useGet<
    ApiResponse<PaginationResponse<ClinicUser & { user: User; clinic: Clinic }>>
  >(token ? '/api/clinic-users' : null, params, token ?? '', undefined, {
    keepPreviousData: true,
  })

  return {
    clinicUsers: data?.data?.items,
    pagination: data?.data
      ? {
          page: data.data.page,
          pageSize: data.data.pageSize,
          total: data.data.total,
          totalPages: data.data.totalPages,
        }
      : undefined,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
